import React from 'react';

import { Typography } from '@mui/material';
import { ToggleSwitch } from 'src/components';
import { Apollo } from 'src/gql/generated';
import { makeStyles } from 'tss-react/mui';

import type { WorkflowWithLaunchConfig } from './LaunchConfig';
import { LaunchConfigBody } from './LaunchConfig';

interface LaunchConfigToggleProps {
  workflowId: UUID;
}

const useStyles = makeStyles()(theme => ({
  row: {
    alignItems: 'center',
    display: 'flex',
  },
  text: {
    marginLeft: theme.spacing(2),
  },
}));

export function LaunchConfigToggle({ workflowId }: LaunchConfigToggleProps) {
  const { classes } = useStyles();
  const [createWorkflowLaunchConfig] = Apollo.useCreateWorkflowLaunchConfigMutation();
  const [updateWorkflowLaunchConfig] = Apollo.useUpdateWorkflowLaunchConfigMutation();
  const { data, loading } = Apollo.useGetLaunchConfigWorkflowQuery({
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    variables: {
      workflowId,
    },
  });
  const isLaunchConfigEnabled = Boolean(data?.workflow?.launchConfig?.enabled);

  return (
    <>
      <div className={classes.row}>
        <ToggleSwitch
          disabled={loading || !data?.workflow}
          toggle={async () => {
            if (!data?.workflow) return;
            if (data.workflow.launchConfig) {
              return updateWorkflowLaunchConfig({
                variables: {
                  input: {
                    launchConfigId: data.workflow.launchConfig.id,
                    props: {
                      enabled: !isLaunchConfigEnabled,
                    },
                  },
                },
              });
            }

            await createWorkflowLaunchConfig({
              variables: {
                workflowId,
              },
            });
          }}
          toggled={isLaunchConfigEnabled}
        />
        <Typography className={classes.text}>
          {isLaunchConfigEnabled
            ? `Public launch page is turned on.`
            : `Public launch page is turned off.`}
        </Typography>
      </div>
      {data?.workflow?.launchConfig && (
        <>
          <LaunchConfigBody
            workflowWithLaunchConfig={
              {
                ...data.workflow,
                launchConfig: data.workflow.launchConfig,
              } satisfies WorkflowWithLaunchConfig
            }
          />
        </>
      )}
    </>
  );
}
